export default function() {
  const widgetName = 'cardWidgetAmpSocialNetworks';
  const widgetOpts = cardWidgetAmpSocialNetworksOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const w = $(`#${widgetName}`);
      let newSocItems = [];

      data.items.forEach(function(item) {
        const title = item.Title;
        const url = item.URL;
        const imgRaw = item.ImageWithPath;
        const socialClass = `socialNetworkIcon${title}`;
        
        const html = `
          <a href="${url}" target="_blank" class="${socialClass}" onclick="_gaq.push(['_trackSocial', '${title.toLowerCase()}', 'Refer To']);">
            <img src="${imgRaw}" alt="${title}" class="socialNetworkIcon" style="height:40px;width:40px;">
          </a>
        `;

        newSocItems.push(html);
      });

      $('.socialNetworks').html(newSocItems.join(''));

      w.remove();

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 6,
    moreButton: {
      visible: false,
      text: 'Buy Tickets'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: true
  });

}